import axios from 'axios'
import qs from 'qs'

export const assessmentJourneyService = ({
  createReflectionElement (token, elementObj) {
    var stringifiedObj = qs.stringify(elementObj)
    return axios.post('/api/Personalization/CreateReflection', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createMCQElement (token, elementObj) {
    var stringifiedObj = qs.stringify(elementObj)
    return axios.post('/api/Personalization/CreateMCQ', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateReflectionElement (token, elementObj) {
    var stringifiedObj = qs.stringify(elementObj)
    return axios.put('/api/Personalization/UpdateReflection', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateMCQElement (token, elementObj) {
    var stringifiedObj = JSON.stringify(elementObj)
    return axios.put('/api/Personalization/UpdateMCQ?isFromCSV=true', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'}})
  },
  deleteElement (token, elementId) {
    return axios.delete('/api/Assessment/DeleteElement?elementId=' + elementId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/assessment-journey-service.js